import { makeObservable, observable, action } from 'mobx'
// import api from '../api/api'
import { JSX } from 'react'
import { DeviceWidths } from '../shared/src/types/Miscs'

export interface clicktipStoreModel {
  clicktips:Clicktip[]
  setSeen: (i:number, status:boolean) => void
}

export type Clicktip = {
  id:string,
  content:JSX.Element|string,
  context:string,
  seen:boolean,
  showAfter?:string,
  sx?:any,
}

class clicktipStore {
  clicktips: Clicktip[] = [
    {
      id:'welcome',
      content: <div>Herzlich Willkommen!<p>Hier könnte ein längerer Text zu SHRIMP stehen und dazu, was Pods sind und so weiter. Oder eben ein Bild oder Video. Auf jeden Fall kann hier etwas stehen :D</p></div>,
      context: '',
      seen:false
    },{
      id: 'account',
      content: 'Hier kannst Du Dich ausloggen, Deinen Namen ändern und andere Einstellungen an Deinem Account vornehmen.',
      context: '',
      seen:false,
      showAfter: 'welcome'
    },{
      id: 'home',
      content: 'Hier kommst Du zur übersicht all deiner pods.',
      context: '',
      seen:false,
      showAfter: 'account'
    }
  ]

  constructor() {
    makeObservable(this, {
      clicktips: observable,
      setSeen: action,
    })
  }

  setSeen = (i:number, status:boolean) => {
    this.clicktips[i].seen = status
  }

}

const exportClicktipStore = new clicktipStore()

export default exportClicktipStore